import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { ASSETS } from "../data";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#050505] noise-overlay flex items-center justify-center px-6 py-20">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 max-w-lg w-full border border-white/10 bg-[#0a0a0a] p-10 lg:p-14 text-center"
      >
        <img src={ASSETS.logo} alt="Ghost The Grid" className="h-14 w-14 object-cover rounded-sm mx-auto mb-8" />
        <h1 className="font-display font-black uppercase tracking-tight text-4xl mb-4">Checkout cancelled</h1>
        <p className="font-body text-white/55 leading-relaxed mb-10">
          No charge was made. The grid is still watching, whenever you're ready to disappear, the pack is waiting.
        </p>
        <Link
          to="/"
          data-testid="cancel-back-button"
          className="group inline-flex items-center justify-center gap-3 bg-accent text-white font-mono uppercase tracking-[0.15em] text-sm px-8 py-5 hover:bg-white hover:text-black transition-colors duration-300 w-full"
        >
          <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" /> Back to the pack
        </Link>
      </motion.div>
    </div>
  );
}
